import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ListButton,
  NumberField,
  Pagination,
  TextField,
  TextInput,
  useRecordContext,
} from "react-admin";
import ImageEye from "@mui/icons-material/RemoveRedEye";
import SchoolIcon from "@mui/icons-material/School";

const filters = [
  <TextInput label="UserId" source="user_id" alwaysOn />,
  <TextInput
    source="first_name"
    alwaysOn
    name="first_name"
    label="First Name"
  />,
  <TextInput source="last_name" alwaysOn name="last_name" label="Last Name" />,
  <TextInput source="email" alwaysOn name="email" label="Email" />,
];

const LinkToThreads = () => {
  const record = useRecordContext();
  const { id } = record;
  return (
    <ListButton icon={<ImageEye />} to={`/threads/${id}`} label={"Threads"} />
  );
};

const LinkToLearning = () => {
  const record = useRecordContext();
  const { id } = record;
  return (
    <ListButton
      icon={<SchoolIcon />}
      to={`/users/${id}/learning`}
      label={"Learning"}
    />
  );
};

export const LearningUsersList = () => {
  return (
    <List
      resource="learning-users"
      filters={filters}
      perPage={50}
      sort={{ field: "last_activity", order: "DESC" }}
      pagination={
        <Pagination perPage={50} rowsPerPageOptions={[10, 25, 50, 100]} />
      }
    >
      <Datagrid>
        <TextField source="id" label="UserId" sortable={false} />
        <TextField source="first_name" label="First Name" sortable={false} />
        <TextField source="last_name" label="Last Name" sortable={false} />
        <TextField source="email" label="Email" sortable={false} />
        <NumberField source="completed_count" label="Completed" />
        <NumberField source="in_progress_count" label="In Progress" />
        <NumberField source="current_streak" label="Streak" sortable={false} />
        <DateField source="last_activity" label="Last Activity" showTime />
        <LinkToThreads />
        <LinkToLearning />
      </Datagrid>
    </List>
  );
};
